export const gameFeed = {
  gameFeed: "Game Feed",
  gameFeedTitle: "Game Feed",
  gameFeedLoading: "Loading game...",
  gameFeedLike: "Like",
  gameFeedUnlike: "Unlike",
  gameFeedLikeSingular: "like",
  gameFeedLikePlural: "likes",
  gameFeedComments: "Comments",
  gameFeedNoComments: "No comments yet. Be the first!",
  gameFeedAddComment: "Add a comment...",
  gameFeedCommentModerated:
    "Your comment was not posted because it goes against our platform policy. Please keep comments respectful.",
  gameFeedCommentSupportRedirect:
    "For withdrawal or payment inquiries, please contact our support team. This section is for game comments only.",
  gameFeedPost: "Post",
  gameFeedDelete: "Delete",
  gameFeedLoginToComment: "Log in to leave a comment",
  gameFeedLoginToLike: "Log in to like games",
  gameFeedReply: "Reply",
  gameFeedReplyPlaceholder: "Write a reply...",
  gameFeedViewReplies: "View replies ({{count}})",
  gameFeedViewMoreReplies: "View more replies",
  gameFeedHideReplies: "Hide replies",
  gameFeedEndOfFeed: "You've seen all the games!",
  gameFeedCloseGame: "Close game",
  gameFeedExpandGame: "Expand game to fullscreen",
  gameFeedDeposit: "Deposit",
  gameFeedBadgeHot: "Hot",
  gameFeedBadgeNew: "New",
  gameFeedBadgeBigWinner: "Big Win",
  gameFeedSwipeForAnotherGame: "Swipe here for another game",
  providerProfileBack: "Back",
  providerProfileGames: "Games",
  providerProfileFollowers: "Followers",
  providerProfileFollow: "Follow",
  providerProfileFollowing: "Following",
  providerProfileGridView: "Grid view",
  providerProfileListView: "List view",
  providerProfileNoGames: "No games available from this provider yet.",
  providerProfileClose: "Close",
  providerProfilePlayGame: "Play game",
  providerDescDefault: "Online casino game provider.",
  providerDescPragmatic:
    "Global leader in slots and live games. Creators of Gates of Olympus, Sweet Bonanza, and Wolf Gold.",
  providerDescBgaming: "Innovative iGaming studio with provably fair slots, unique mechanics, and vibrant design.",
  providerDescEvoplay: "Pioneers in 3D gaming and gamification. Immersive experiences with cinematic storytelling.",
  providerDescHacksaw: "Specialists in digital scratch cards and high-volatility slots with extreme payouts.",
  providerDescEvolution: "#1 in live casino. Roulette, blackjack, game shows, and real-time interactive experiences.",
  providerDescPixmove: "Emerging studio with arcade-casino hybrid games and skill gaming mechanics.",
  providerDescUpgaming: "Provider of classic and modern slots with progressive jackpots and bonus features.",
  providerDescEndorphina: "Premium slots with cultural themes, high-quality graphics, and precise mathematics.",
  providerDescBetby: "Leading sports betting platform covering 30,000+ monthly events.",
  providerDescTada: "Asian studio with colorful slots, massive multipliers, and addictive mechanics.",
  providerDescGamingcorps: "Swedish developer of slots and table games focused on quality and fair play.",
  providerDescKagaming: "Asian provider with a wide catalog of themed slots, fishing, and table games.",
  gameFeedFilterTitle: "Filters",
  gameFeedFilterAll: "All",
  gameFeedFilterTopPlayed: "Top 10",
  gameFeedFilterTournament: "Tournament",
  gameFeedFilterDrop: "Drop",
  gameFeedFilterRace: "Race",
  gameFeedFilterSectionType: "Feed Type",
  gameFeedFilterSectionProvider: "Provider",
  gameFeedFilterSectionFeatures: "Features",
  gameFeedFilterSelectProviderFirst: "Select a provider to enable features",
  gameFeedFilterClear: "Clear filters",
  gameFeedFilterNoResults: "No games match these filters",
  gameFeedFilterShowMore: "Show more",
  gameFeedFilterShowLess: "Show less",
  gameFeedFilterNoGamesType: '{{provider}} has no "{{type}}" games',
  gameFeedFilterNoFeature: "{{provider}} has no active {{feature}}",
  gameFeedFilterAccept: "Apply",
  storyTopGamesTitle: "Top 3 most played on {{provider}}",
};
